import { Injectable } from '@angular/core';
import { Box, BoxType, BoxAudit, PointerLocation } from '../types';
//import { Headers, Response, Http, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Rx'
import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
@Injectable()
export class BoxService {
  private BoxsUrl = 'api/boxes';
  private BoxTypesUrl = 'api/boxtypes';

  constructor(private http: HttpClient) { }

  getBoxs(): Observable<Box[]> {
    return this.http.get<Box[]>(this.BoxsUrl)
      //.map((res:Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getBoxByLocationId(id: Number): Observable<Box[]> {
    const url = `api/boxes/${id}`;
    return this.http.get<Box[]>(url)
      //.map((res:Response) => res.json())
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  getChildBoxes(id: number): Observable<Box[]> {
    const url = `api/childboxes/${id}`;
    return this.http.get<Box[]>(url)
      //.map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  getBoxByBoxId(id: Number): Observable<Box> {
    const url = `api/box/${id}`;
    return this.http.get<Box>(url)
      //.map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  printLabel(id: Number): Observable<Box> {
    const url = `api/boxlabel/${id}`;
    return this.http.get<Box>(url)
      //.map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error._body || 'Server error'));
  }

  getBoxAudits(id: number): Observable<BoxAudit[]> {
    const url = `api/boxaudit/${id}`;
    return this.http.get<BoxAudit[]>(url)
      //.map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  getBoxLocations(id: Number, _when: Date): Observable<PointerLocation[]> {
    const url = `/api/boxmap/${id}/${_when}`
    return this.http.get<PointerLocation[]>(url)
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  getBoxTypes(): Observable<BoxType[]> {
    return this.http.get<BoxType[]>(this.BoxTypesUrl)
      //.map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  saveBox(box: Box): Observable<Box> {
    return this.http.post<Box>(this.BoxsUrl, box)
      //.map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  putBox(box: Box): Observable<Box> {
    return this.http.put<Box>(this.BoxsUrl, box)
      //.map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  printUnpackLabels(boxid: number, shouldPrint: number): Observable<any> {
    const url = `api/printlabelqueue/${boxid}/${shouldPrint}`;
    return this.http.post(url,null)
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  emptyBox(boxid: number): Observable<any> {
    const url = `api/boxempty/${boxid}`;
    return this.http.post(url, null)
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  moveBoxSamples(startid: number, endid: number): Observable<string> {
    const url = `api/moveboxsamples/${startid}/${endid}`;
    return this.http.post<string>(url, null)
      //.map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  packChildBox(box: Box): Observable<number> {
    return this.http.post<number>('api/packchildbox', box)
      //.map((res: Response) => res.json())
      .catch((error: Response) => Observable.throw(error || 'Server error'));
  }
}
